const urlForKit = ({ name, kitId, prefix }) => {
	const slugPathPart = name ? `${name.toLowerCase().replace(/[^a-z0-9]/gi, '-')}/` : ''
	let kitUrl = `/kit/${slugPathPart}${kitId}`
	if (prefix) {
		kitUrl = (prefix[prefix.length - 1] === '/' ? prefix.substr(0, prefix.length - 1) : prefix) + kitUrl
	}
	return kitUrl
}

export default urlForKit



// WEBPACK FOOTER //
// ./src/utilities/urlForKit.js